import { render } from "./PostListView.vue?vue&type=template&id=5dbad516"
import script from "./PostListView.vue?vue&type=script&lang=js"
export * from "./PostListView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/views/PostListView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5dbad516"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5dbad516', __exports__)) {
    api.reload('5dbad516', __exports__)
  }
  
  module.hot.accept("./PostListView.vue?vue&type=template&id=5dbad516", () => {
    api.rerender('5dbad516', render)
  })

}


export default __exports__